var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-popup-log-history",style:(_vm.popupPosition)},_vm._l((_vm.details),function(ref,index){
var eventDescription = ref.eventDescription;
var eventDate = ref.eventDate;
return _c('div',{key:index,staticClass:"bb-popup-log-history-item"},[(_vm.isChange)?_c('div',{staticClass:"bb-popup-log-history-item__title",class:[
        index === 1 && 'bb-popup-log-history-item__title_update'
      ]},[_vm._v("\n      "+_vm._s(index === 0 ? 'Before' : 'After')+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bb-popup-log-history-item__date"},[_vm._v("\n      "+_vm._s(_vm.dateFormat(eventDate))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"bb-popup-log-history-item__desc",class:[
        index === 0 && _vm.isChange && 'bb-popup-log-history-item__desc_update'
      ]},[_vm._v("\n      "+_vm._s(eventDescription)+"\n    ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bb48c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/PopupLogHistory/PopupLogHistory.vue
// module id = null
// module chunks = 